import { Link } from "react-router-dom";

export function ProviderFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-[#D9D9D9]">
      <div className="lg:mx-auto lg:max-w-[min(1548px,_calc(100%-24px))] max-w-full px-4 py-10">
        {/* Mobile: centered column */}
        <div className="flex flex-col items-center text-center lg:hidden">
          <Link to="/provider">
            <img
              src="/images/logo.svg"
              alt="삼척 돌봄e음"
              className="h-16 object-contain"
            />
          </Link>

          <div className="flex items-center gap-4 sm:gap-5 mt-[40px] mb-[20px] text-[14px] font-semibold leading-[150%]">
            <Link
              to="/privacy"
              className="font-bold text-[#F87400] hover:underline"
            >
              개인정보처리방침
            </Link>
            <div className="shrink-0 h-5 w-px bg-[#CCCCCC]"></div>
            <Link to="/email-policy" className="text-[#000000] hover:underline">
              이용약관
            </Link>
            <span className="shrink-0 h-5 w-px bg-[#CCCCCC]"></span>
            {/* <Link to="/sitemap" className="text-[#000000] hover:underline">
              사이트맵
            </Link> */}
          </div>

          <div className="text-sm text-[#595758] leading-relaxed space-y-1">
            <p>
              (25913) 강원특별자치도 삼척시 중앙로 346
              <br />
              EDUPIA삼척교육발전사업단 (강원대학교 삼척산학협력단)
            </p>
            <p className="mt-2">대표전화 : 033-570-6841</p>
            <p className="mt-3">
              본 누리집에 게시된 전자우편 주소는 무단으로 수집될 수 없으며, 위반
              시 정보통신망법에 의해 처벌됨을 유념하시기 바랍니다.
            </p>
          </div>

          <hr className="w-full mt-[40px] border-t border-[#D9D9D9]" />
          <div className="pt-[20px] text-sm text-[#595758]">
            <p>
              Copyright {currentYear} &copy; EDUPIA삼척교육발전사업단.
              <br />
              All rights reserved.
            </p>
          </div>
        </div>

        {/* Wide: logo left, content right */}
        <div className="hidden lg:flex lg:items-center gap-10">
          <Link to="/provider" className="flex-shrink-0">
            <img
              src="/images/logo.svg"
              alt="삼척 돌봄e음"
              className="h-16 object-contain"
            />
          </Link>

          <div className="flex-1">
            <div className="flex items-center gap-5 text-[20px] font-semibold leading-[100%]">
              <Link
                to="/privacy"
                className="font-bold text-[#F87400] hover:underline"
              >
                개인정보처리방침
              </Link>
              <Link
                to="/email-policy"
                className="text-[#000000] hover:underline"
              >
                이용약관
              </Link>
              {/* <Link to="/sitemap" className="text-[#000000] hover:underline">
                사이트맵
              </Link> */}
            </div>

            <hr className="mt-5 mb-5 border-t border-[#D9D9D9]" />

            <div className="text-[14px] font-normal leading-[100%] text-[#595758]">
              <p className="flex flex-wrap gap-x-[30px] xl:gap-x-[50px]">
                <span>
                  (25913) 강원특별자치도 삼척시 중앙로 346
                  EDUPIA삼척교육발전사업단(강원대학교 삼척산학협력단)
                </span>
                <span>대표전화 : 033-570-6841</span>
              </p>
              <p className="mt-2">
                본 누리집에 게시된 전자우편 주소는 무단으로 수집될 수 없으며,
                위반 시 정보통신망법에 의해 처벌됨을 유념하시기 바랍니다.
              </p>
              <p className="mt-4">
                Copyright {currentYear} &copy; EDUPIA삼척교육발전사업단. All
                rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
